export default {
  setPatientDashBoard (state, payload) {
    state.patientInjectDashboard = payload
  },
  setClinicLocation (state, payload) {
    state.selectedClinicLocation = payload
  },
  setClinicStaff (state, payload) {
    state.selectedClinicStaff = payload
  },
  setShowLoadingScreen (state, status) {
    state.showLoadingScreen = status
  },
  setAlertMessage (state, payload) {
    state.alertMessage.open = payload.open
    state.alertMessage.msg = payload.msg
    if (payload.title) {
      state.alertMessage.title = payload.title
    }
    if (payload.type) {
      state.alertMessage.type = payload.type
    }
  },
  setMaxSizeUpload (state, payload) {
    state.maxSizeUpload = payload
  },
  setOpenModalLogin (state, payload) {
    state.openModalLogin = payload
  },
  setAuthenticated (state, payload) {
    state.authenticated = payload
  },
  setSettingMode (state, payload) {
    state.user.settingMode = payload
  },
  setUser (state, payload) {
    if (state.user) {
      state.user.avatar = payload.avatar
      state.user.email = payload.email
      state.user.fullName = payload.fullName
      state.user.id = payload.id
      state.user.role = payload.role
      state.user.clinicIdWiki = payload.clinicIdWiki
    }
  },
  setTotalSizeUploaded (state, payload) {
    state.totalSizeUploaded = payload
  },
  setFullScreen (state, payload) {
    state.isFullScreen = payload
  },
  setWorkingStatus (state, timeOut) {
    state.workingStatusTimeOut = timeOut
    state.workingStatusLastRequest = new Date()
  },
  setWorkingTimeOut (state, timeOut) {
    state.workingStatusTimeOut = timeOut
  },
  setDateFilterSave (state, payload) {
    state.dateFilterSave = payload
  },
  resetDateFilter (state) {
    state.dateFilterSave = -1
  },
  resetDateRangeBill (state) {
    state.dateRangeBill = {
      fromDate: -1,
      toDate: -1
    }
  },
  setDateRangeBill (state, payload) {
    state.dateRangeBill = payload
  },
  setLockQuestionScreen (state, payload) {
    state.lockQuestionScreen = payload
  },
  setCondenseConventional (state, payload) {
    state.condenseDashboard.conventional = payload
  },
  setCondenseRush (state, payload) {
    state.condenseDashboard.rush = payload
  },
  setCondenseBiologic (state, payload) {
    state.condenseDashboard.biologic = payload
  },
  setDataRecordCurrent (state, payload) {
    state.dataRecordEncounterCurrent = payload
  }
}
